/* Pixel Threads - Signal Rotation
   Rotates the hero eyebrow line. Copy comes from the signal generator with a
   local fallback pool. Changes fire on pt:signal-tune, so the line and the
   emblem move on one beat instead of two drifting timers. */
(function () {
  'use strict';

  var ENDPOINT = 'https://pt-signal-generator.mind-giant-studios.workers.dev/';
  var STORE_KEY = 'pt_signal';
  var FADE_OUT = 160;
  var FADE_IN = 260;
  var QUEUE_TARGET = 2;
  var MAX_LEN = 120;

  var FALLBACK = [
    'THE PATTERN PRECEDES THE PIECE.',
    'EVERY THREAD CARRIES A CODE.',
    'THE CODE WAS HERE BEFORE THE NOISE.',
    'SIGNAL INTACT. IDENTITY PRESERVED.',
    'YOU WERE ALWAYS THE SIGNAL.'
  ];

  var targets = [], queue = [], fallbackAt = 0, last = '', inFlight = false, busy = false, paused = false;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    targets = [].slice.call(document.querySelectorAll('[data-signal-text]'));
    if (!targets.length) return;

    try { last = window.sessionStorage.getItem(STORE_KEY) || ''; } catch (e) {}

    targets.forEach(function (el) {
      el.style.transition = 'opacity ' + FADE_IN + 'ms ease';
    });

    prime();
    /* first line lands as soon as one is available, animation or not */
    waitForLine(function (text) { render(text); });

    if (!reduce) (function () { targets.forEach(function (el) { el.setAttribute('tabindex', '0'); el.setAttribute('aria-live', 'off'); el.addEventListener('mouseenter', pause); el.addEventListener('mouseleave', resume); el.addEventListener('focusin', pause); el.addEventListener('focusout', resume); }); window.addEventListener('pt:signal-tune', swap); })();
  });

  /* ---- copy supply ------------------------------------------------------ */

  function clean(value) {
    if (typeof value !== 'string') return '';
    var text = value.replace(/\s+/g, ' ').trim();
    return text.length && text.length <= MAX_LEN ? text : '';
  }

  function prime() {
    if (inFlight || queue.length >= QUEUE_TARGET || !window.fetch) return;
    inFlight = true;
    window.fetch(ENDPOINT, { mode: 'cors', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var text = data ? clean(data.message) : '';
        if (text) queue.push(text);
      })
      .catch(function () {})
      .then(function () { inFlight = false; });
  }

  function nextLine() {
    var text = queue.shift();
    if (!text || text === last) {
      var guard = 0;
      do {
        text = FALLBACK[fallbackAt % FALLBACK.length];
        fallbackAt++;
        guard++;
      } while (text === last && guard < FALLBACK.length);
    }
    prime();
    return text;
  }

  function waitForLine(fn) {
    if (queue.length) { fn(nextLine()); return; }
    var tries = 0;
    var poll = window.setInterval(function () {
      tries++;
      if (queue.length || tries > 12) {
        window.clearInterval(poll);
        fn(nextLine());
      }
    }, 120);
  }

  /* ---- render ----------------------------------------------------------- */

  function render(text) {
    if (!text) return;
    last = text;
    try { window.sessionStorage.setItem(STORE_KEY, text); } catch (e) {}
    targets.forEach(function (el) { el.textContent = text; });
  }

  function pause() { paused = true; }

  function resume() { paused = false; }

  function swap() {
    if (busy || paused) return;
    busy = true;
    var text = nextLine();
    targets.forEach(function (el) {
      el.style.transition = 'opacity ' + FADE_OUT + 'ms ease';
      el.style.opacity = '0';
    });
    window.setTimeout(function () {
      render(text);
      targets.forEach(function (el) {
        el.style.transition = 'opacity ' + FADE_IN + 'ms ease';
        el.style.opacity = '1';
      });
      window.setTimeout(function () { busy = false; }, FADE_IN);
    }, FADE_OUT);
  }
}());